<template>
<div class="bg-culture-grey">
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <b-container class="mt-5">
        <Activation />
        <div class="">
            <b-row style="margin-left:0 !important">
                <div class="col-md-9 outer-div">
                    <b-row class="mt-2 text-center" align-h="center">
                        <b-col cols="12" md="2" @click="loadData('language-club',  $event)" role="button" class="border-primary mb-2 p-2 ml-2 mr-custom active">
                            Lang Club</b-col>
                        <b-col cols="12" md="2" @click="loadData('instructor', $event)" role="button" class="border-primary mb-2 p-2 ml-2 mr-custom">
                            Instructor</b-col>
                        <b-col cols="12" md="2" @click="loadData('interpreter', $event)" role="button" class="border-primary mb-2 p-2 ml-2 mr-custom">
                            Interpreter</b-col>
                        <b-col cols="12" md="2" @click="loadData('donate', $event)" role="button" class="border-primary mb-2 p-2 ml-2 mr-custom">
                            Donate</b-col>
                        <b-col cols="12" md="2" @click="loadData('vendor', $event)" role="button" class="border-primary mb-2 p-2 ml-2 mr-custom">Be
                            a
                            Vendor</b-col>
                    </b-row>
                    <b-row class="mt-2 text-center" align-h="center">
                        <b-col cols="12" md="2" @click="loadData('cook', $event)" role="button" class="border-primary mb-2 p-2 ml-2 mr-custom">
                            Chef/Cook</b-col>
                        <b-col cols="12" md="2" @click="loadData('recipe', $event)" role="button" class="border-primary mb-2 p-2 ml-2 mr-custom">
                            Recipes</b-col>
                        <b-col cols="12" md="2" @click="loadData('host-event', $event)" role="button" class="border-primary mb-2 p-2 ml-2 mr-custom">
                            Host
                            Event</b-col>
                        <b-col cols="12" md="2" @click="loadData('join-event', $event)" role="button" class="border-primary mb-2 p-2 ml-2 mr-custom">
                            Join
                            Event</b-col>
                        <b-col cols="12" md="2" @click="loadData('product', $event)" role="button" class="border-primary mb-2 p-2 ml-2 mr-custom">
                            Buy
                            Products</b-col>
                    </b-row>

                    <b-row class="mt-3" align-h="center" v-if="isdefault">
                        <b-col class="border-primary p-5 mb-3 ml-2 mr-custom">
                            <ul>
                                <li>Select your local language</li>
                                <li>Name your language club</li>
                                <li>Set admission rules: It is free or paid membership?</li>
                                <li>Publish your calendar</li>
                                <li>Start admitting members and earn an income</li>
                            </ul>
                            <div class="text-center mt-3">
                                <router-link to="/languages/clubs/create" class=" btn font12 btn-warning">
                                    Start Here
                                </router-link>

                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3" align-h="center" v-if="!isdefault">
                        <b-col class="border-primary p-5 mb-3 ml-2 mr-custom">
                            <ul>
                                <li v-for="(data, index) in viewData.text" :key="index">
                                    {{data}}
                                </li>
                            </ul>
                            <div class="text-center mt-3">
                                <router-link v-if="!viewData.extLink" :to="viewData.url" class=" btn font12 btn-warning">
                                    {{viewData.actionText}}
                                </router-link>
                                <a target="_blank" v-if="viewData.extLink" :href="viewData.url" class=" btn font12 btn-warning">
                                    {{viewData.actionText}}
                                </a>
                            </div>
                        </b-col>
                    </b-row>

                </div>

                <div class="col-md-3 shadow-box">
                    <b-col v-if="!isdefault" class=" img-bg p-1" v-bind:style='{ backgroundImage: "url(" + viewData.imgUrl + ")", }'>
                        <img src="" alt="">
                    </b-col>
                    <b-col v-if="isdefault" class=" img-bg p-1" v-bind:style='{ backgroundImage: "url(" + defaultImgUrl + ")", }'>
                        <img src="" alt="">
                    </b-col>

                </div>

            </b-row>
        </div>

    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
 import {
    dashboardData
} from "../../utils/common";
export default {
    name: 'dashboard',
    components: {
        Header,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Activation,
        Footer
    },
    data: function () {
        return {
            headerText: "Dashboard",
            subText: "One Stop Shop",
            fadedText: "Dashboard",
            defaultImgUrl: require('@/assets/images/lang-club.jpg'),
            active: false,
            viewData: [{
                text: [],
                actionText: '',
                url: '/'
            }],
            isdefault: true
        }
    },
    methods: {
        toggleClass: function (e) {
            const boxes = document.querySelectorAll('.mr-custom');
            boxes.forEach(box => {
                box.classList.remove('active');
            });
            e.target.classList.add("active");
            this.isdefault = false
        },
        loadData(data, e) {
            let [{
                langClub,
                cook,
                instructor,
                interpreter,
                recipe,
                donate,
                joinEvent,
                hostEvent,
                vendor,
                product
            }] = dashboardData
            switch (data) {
                case 'language-club':
                    this.viewData = langClub
                    this.toggleClass(e)
                    break;
                case 'instructor':
                    this.viewData = instructor
                    this.toggleClass(e)
                    break;
                case 'interpreter':
                    this.viewData = interpreter
                    this.toggleClass(e)
                    break;
                case 'donate':
                    this.viewData = donate
                    this.toggleClass(e)
                    break;
                case 'vendor':
                    this.viewData = vendor
                    this.toggleClass(e)
                    break;
                case 'cook':
                    this.viewData = cook
                    this.toggleClass(e)
                    break;
                case 'recipe':
                    this.viewData = recipe
                    this.toggleClass(e)
                    break;
                case 'join-event':
                    this.viewData = joinEvent
                    this.toggleClass(e)
                    break;
                case 'host-event':
                    this.viewData = hostEvent
                    this.toggleClass(e)
                    break;
                case 'product':
                    this.viewData = product
                    this.toggleClass(e)
                    break;
                default:
                    this.viewData = langClub
                    this.toggleClass(e)
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.border-primary {
    border: 1px solid #F7B131 !important;
    border-radius: 5px;
}

.mr-custom {
    margin-right: 1.17rem;

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-right: 0rem;
    }
}

ul {
    list-style: disc !important
}

.img-bg {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 25em;
    border-radius: 1rem;

}

.shadow-box {
    background: rgba(86, 92, 99, 0.05);
    box-shadow: 2px 6px 19px rgb(0 0 0 / 5%);
    border-radius: 0px 0px 16px 16px;
    // padding: 30px 30px 60px 30px;

    // @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
    //     padding: 30px 10px 60px 10px;
    // }
}

.active {
    background: #F7B131;
    color: #fff;
}
</style>
